import React__default from 'react';
import BottomSheet from './BottomSheet.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../chunks/bundle-ZBp236Ey.js';
import { u as useLocalization } from '../chunks/bundle-BSUtC3cw.js';
import 'react-dom';
import '../hooks/useModal.js';
import '../chunks/bundle-j5GfJ6DZ.js';
import '../chunks/bundle-Cj_4CfJM.js';
import '../chunks/bundle-idC_wVZi.js';
import '../chunks/bundle-B4W1Qw_4.js';
import '../chunks/bundle-DvCKSiBl.js';
import './IconButton.js';
import './Button.js';
import './Icon.js';
import '../chunks/bundle-B7LMd75S.js';
import '../chunks/bundle-DloqDvm2.js';
import '../chunks/bundle-BC1GKYVu.js';
import '../chunks/bundle-C6g3HNED.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import '../chunks/bundle-BjDPDV1u.js';
import '../chunks/bundle-CnQtgeX8.js';

function MobileFeedbackMenu(props) {
    var hideMenu = props.hideMenu, onEditFeedback = props.onEditFeedback, onRemoveFeedback = props.onRemoveFeedback;
    var stringSet = useLocalization().stringSet;
    return (React__default.createElement(BottomSheet, { onBackdropClick: hideMenu },
        React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-options-menu' },
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onEditFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.EDIT_COMMENT)),
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onRemoveFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ERROR }, stringSet.REMOVE_FEEDBACK)))));
}

export { MobileFeedbackMenu as default };
//# sourceMappingURL=MobileFeedbackMenu.js.map
